import { useEffect } from 'react';

import Sentry from 'libs/Sentry';

import { initLogger } from 'utils/logger';
import 'utils/yupUtils/index';

import useSetProjectsToStore from '../fetchData/useSetProjectsToStore';
import { init } from '@amplitude/analytics-browser';
import { useAppContext } from 'store/AppProvider';

import config from 'config';

const useAppInit = () => {
    const { appState } = useAppContext();
    const userData = appState.user.user;

    useEffect(() => {
        if (userData) {
            Sentry.setUserData(userData);
        }
    }, [userData]);

    useEffect(() => {
        initLogger();
        if (config.ENV === 'prod' && config.AMPLITUDE_API_KEY) {
            init(config.AMPLITUDE_API_KEY, { autocapture: true });
        }
    }, []);

    useSetProjectsToStore();
};

export { useAppInit };
